<template>
  <div class="user-reset-password">
  <div id="main-card" class="card w-50 mx-auto p-5 d-flex align-items-center rounded shadow">
  <!--QRP LOGO START-->
  <div class="container h-100">
  <div class="row justify-content-md-center">
    <div class="col-12 mx-auto">
      <img id="qrp-logo" :src="require(`../../assets/clients/${agencyLogo}.svg`)" alt="Rating Platform Logo" width="100%" height="auto" v-if="agencyLogo" />
      <img id="qrp-logo" src="../../assets/qrp-rtm-color.svg" alt="QuinStreet Rating Platform" width="100%" height="auto" v-else />
    </div>
  </div>
  </div>
  <!--QRP LOGO END-->
  <div id="card-inner-container" class="mx-auto w-100">

  <div class="row justify-content-md-center">
  <div class="col-12">
  <div class="row">
    <div class="col-12 col-lg-10 col-xl-7 mx-auto">
      <hr id="login-card-hr">
    </div>
  </div>
  <form v-if="viewUsage" class="my-3">
    <div class="row">
      <div class="col-12 col-lg-10 col-xl-7 mx-auto">
        <h1 class="text-center text-primary">{{ displayContent[viewUsage].displayTitle }}</h1>
        <p class="text-center smaller-font-content">{{ displayContent[viewUsage].displayDescription }}</p>
      </div>
    </div>

    <div v-if="viewUsage === 'reset' || viewUsage === 'expired' || viewUsage === 'expiredReset'" class="form-row mx-0">
        <div class="form-group col-12 col-lg-10 col-xl-7 mb-0 px-2 mx-auto">
          <field-label :fieldData="fieldElement['userEmail']"></field-label>

          <field-tooltip :fieldData="fieldElement['userEmail']"></field-tooltip>

          <input-text :fieldData="fieldElement['userEmail']" :ref="userNameRef"></input-text>

          <field-messages :fieldData="fieldElement['userEmail']"></field-messages>
        </div>
    </div>
    <!--2 Column Wrapper-->

    <password-update v-if="viewUsage === 'update'"
      :fieldElement="fieldElement"
      :passwordInputType="passwordInputType">
    </password-update>

    <div class="col-md-12 form-group text-center text-notice">
      <form-messages :formMessages="formMessages"></form-messages>
    </div>

    <div class="text-center">
      <button v-if="viewUsage === 'reset' || viewUsage === 'expired'" type="submit" class="btn btn-primary mx-3 mb-2 mb-md-0" @click.prevent="requestPasswordToken">Reset Password</button>
      <button v-if="viewUsage === 'expiredReset'" type="submit" class="btn btn-primary mx-3" @click.prevent="requestPasswordToken">Request Link</button>
      <button v-if="viewUsage === 'update'" type="submit" class="btn btn-primary mx-3" @click.prevent="updatePassword">Reset Password</button>
      <a v-if="viewUsage === 'reset'" href="" class="text-link qrp-text-muted small mx-3" @click.prevent="$router.push({ name: 'login' })">Cancel</a>
      <button v-if="viewUsage === 'expiredReset'" class="btn btn-muted" @click.prevent="$router.push({ name: 'login' })">Login</button>
    </div>
  </form>
  <div class="row">
    <div class="col-12 col-lg-10 col-xl-7 mx-auto">
      <hr id="login-card-hr-bottom">
    </div>
  </div>
  </div>
  </div>

  <main-footer id="main-footer" role="contentinfo"></main-footer>

  </div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
/* eslint no-undef: */
/* eslint prefer-template:  */

import Footer from '../shared/Footer';
import FieldLabel from '../presentational/FieldLabel';
import FieldMessages from '../presentational/FieldMessages';
import FieldTooltip from '../presentational/FieldTooltip';
import FormMessages from '../presentational/FormMessages';
import InputText from '../interactive/InputText';
import PasswordStrength from '../presentational/alerts/PasswordStrength';
import store from '../../store/store';
import User from '../../services/User';
import PasswordUpdate from '../interactive/widgets/PasswordUpdate';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['guid', 'token'],
  data() {
    return {
      agencyLogo: '',
      viewUsage: null, // Usage for this component is 'update', 'expired', 'expiredReset', 'reset'
      displayContent: { // TODO: Use config value
        reset: {
          displayTitle: 'Forgot your password?',
          displayDescription: 'Enter your account email address to reset your password.',
        },
        expired: {
          displayTitle: 'Your password has expired.',
          displayDescription: 'Enter your account email address to reset your password.',
        },
        update: {
          displayTitle: 'Reset your password.',
          displayDescription: 'Your password must meet our minimum security requirements.',
        },
        expiredReset: {
          displayTitle: 'This reset link has expired.',
          displayDescription: 'Enter your account email address to request another reset password link.',
        },
      },
      formMessages: [],
      userNameRef:'',
      fieldElement: {
        username: {
          label: 'Username',
          field_type: 'text_long',
          field_prepend: 'user',
          field_name: 'username',
          is_required: true,
          help_text: '',
          field_value: '',
          field_validation_rules: '',
          is_enabled: true,
          visible: true,
          max_length: 50,
        },
        userEmail: {
          label: 'Account Email',
          field_type: 'text_long',
          field_prepend: 'envelope',
          field_name: 'user_email',
          is_required: true,
          help_text: '',
          field_value: '',
          field_validation_rules: '',
          is_enabled: true,
          visible: true,
          max_length: 50,
        },
        password: {
          label: 'Password',
          field_type: 'password_long',
          field_prepend: 'lock',
          field_name: 'password',
          is_required: true,
          help_text: '',
          field_value: '',
          field_validation_rules: 'min:8|has_alpha_uppercase|has_alpha_lowercase|has_numeric|has_special_char',
          is_enabled: true,
          visible: true,
          max_length: 50,
        },
        passwordConfirm: {
          label: 'Confirm Password',
          field_type: 'password_long',
          field_prepend: 'lock',
          field_name: 'passwordConfirm',
          is_required: true,
          help_text: '',
          field_value: '',
          field_validation_rules: 'confirmed_match:password',
          is_enabled: true,
          visible: true,
          max_length: 50,
        },
        passwordExpose: {
          label: 'Show Password',
          field_type: 'checkbox',
          field_prepend: null,
          field_name: 'passwordExpose',
          field_value: false,
          is_required: false,
          help_text: '',
          field_validation_rules: '',
          is_enabled: true,
          visible: true,
          max_length: 1,
        },
      },
    };
  },
  computed: {
    passwordInputType: function passwordInputType() {
      return (this.fieldElement.passwordExpose.field_value === false ? 'password' : 'text');
    },
  },
  components: {
    mainFooter: Footer,
    FieldLabel,
    FieldMessages,
    FieldTooltip,
    FormMessages,
    InputText,
    PasswordStrength,
    User,
    PasswordUpdate,
  },
  created() {
    if (this.$store.getters.getAgencyLogo) {
      this.agencyLogo = this.$store.getters.getAgencyLogo;
    }
    switch (this.$route.params.viewUsage) {
      case 'expired':
        this.viewUsage = 'expired';
        gtag('config', '<%= process.env.GAID %>', { page_path: '/reset-password/expired' });
        break;
      case 'update':
        this.authenticatePasswordToken(); // Authenticates the user AND sets viewUsage once it resolves
        gtag('config', '<%= process.env.GAID %>', { page_path: '/reset-password/update' });
        break;
      case 'expiredReset':
        this.viewUsage = 'expiredReset';
        break;

      case 'reset':
        this.viewUsage = 'reset';
        gtag('config', '<%= process.env.GAID %>', { page_path: '/reset-password/reset' });
        break;

      default:
        this.$router.push({ name: 'login' });
        break;
    }
     this.userNameRef = this.fieldElement['userEmail'].field_name;
    
    /**
     * Because component's data needs to be able to affect other component's
     * data, the data is stored in the Vuex state management store.
     */
    this.$store.mutatable_data = this.fieldElement; // TODO: Allow for multiple indices

  },
  methods: {
    setViewUsage(isAuthenticated) {
      this.viewUsage = (isAuthenticated ? 'update' : 'expiredReset'); // TODO: Use computed property
    },
    authenticatePasswordToken() {
      User.authenticatePasswordToken(this.guid, this.token).then((response) => {
        this.setViewUsage(response); // `response` is always true/false
      });
    },
    updatePassword() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return; // Short circuit if all field elements are not valid
        }

        User.updatePassword(
          this.guid,
          this.fieldElement.password.field_value,
          this.fieldElement.passwordConfirm.field_value,
          this.token,
        ).then(() => {
          // TODO: Use response (data or http code) to evaluate whether it is a valid account

          this.formMessages = []; // Reset form messages to none
          this.formMessages.push('<div class="my-3"><strong class="success-green">Success! - Password Updated</strong> Your password has been successfully updated. Please remember your new password for the next time you log in.</div>');

          store.dispatch('setPasswordUpdateSuccess', true);

          User.authenticateUser(
            this.guid, // TODO: Create endpoint to accept the `guid`
            this.fieldElement.password.field_value,
          ).catch(() => {
            window.console.warn('User was not authenticated.');
          }).then(() => { // Always attempt to redirect the user to `search`
            this.$router.push({ name: 'search' });
          });
        }).catch((error) => {
          // TODO: Use response (data or http code) to evaluate error

          window.console.warn('An error occurred while updating the user password:', error);

          this.formMessages = []; // Reset form messages to none
          this.formMessages.push('<div class="text-notice error-red my-3">An error has occurred while updating your password. Please try again.</div>');

          return Promise.reject(error);
        });
      });
    },
    requestPasswordToken() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return; // Short circuit if all field elements are not valid
        }

        this.formMessages = []; // Reset form messages to none
        const subDomain = store.getters.getAgencyLogo || "QRP";

        User.requestPasswordToken(this.fieldElement.userEmail.field_value, subDomain).then(() => {
          this.formMessages.push(`<div class="my-3"><strong class="success-green">Success!</strong> We have sent you an
          email with a link to reset your password.</div>`);
        }).catch(() => {
         
          this.formMessages.push(`<div class="text-notice error-red my-3">We're sorry, a system error has 
          occurred. Please try again. If the error persists then contact your manager.</div>`);
         
         this.focusOnEmailInput()
        });
      });
    },
    focusOnEmailInput() {
      this.$refs['user_email'].$refs.user_email.focus();
    }
  },
 
};
</script>

<style scoped>
  #main-card {
    border-color: #F7F7F7;
    margin-top: 4rem;
  }

  #login-card-hr {
    margin: 0.625rem 0;
  }

  #login-card-hr-bottom {
    margin-bottom: .25rem;
  }

  #qrp-logo{
    display: block;
    width: 75%;
    max-width: 230px;
    height: inherit !important;
    margin:0 auto;
  }

  .input-group-prepend svg{
    color: #666666;
    fill: currentcolor;
  }
form h1{
  font-size: 1.375rem !important;
}

#main-footer {
  margin-bottom: 1rem;
  padding-top: .7rem;
  font-size: 0.75rem;
  text-align: center;
}

a.text-link{
  cursor: pointer;
}
a.text-link:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/user/ResetPassword.vue?af9f970e